exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#rayonPageContainer .title{text-align:center;font:normal normal normal 70px/89px Dosis;letter-spacing:0;color:#fff;opacity:1}#rayonPageContainer .subtitle{text-align:center;font:normal normal normal 30px/40px Segoe UI;letter-spacing:0;color:#fff;opacity:1}", ""]);

// exports
